import { useEffect, useMemo, useState } from "react";
import { TopBar } from "../components/TopBar";
import { AppShell, AppFooter } from "../components/Shell";
import { NotificationsBanner } from "../components/NotificationsBanner";
import { BottomNav } from "../components/BottomNav";
import { PairCard } from "../components/PairCard";
import { RaceCountdown } from "../components/RaceCountdown";
import { FiltersDrawer, DEFAULT_FILTERS, applyFilters, sortPairs, countActive } from "../components/PairFilters";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { useT } from "../i18n";

export default function Search() {
  const { profile } = useAuth();
  const { t } = useT();
  const [pairs, setPairs] = useState(null);
  const [races, setRaces] = useState([]);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  useEffect(() => {
    api.get("/pairs").then((r) => setPairs(r.data.pairs)).catch(() => setPairs([]));
    api.get("/races").then((r) => setRaces(r.data)).catch(() => {});
  }, []);

  const cities = useMemo(() => [...new Set((pairs || []).map((p) => p.city))].sort(), [pairs]);
  const visible = useMemo(() => (pairs ? sortPairs(applyFilters(pairs, filters, profile), filters.sort, races, profile?.city) : []), [pairs, filters, races, profile]);
  const filtering = countActive(filters) > 0;

  return (
    <AppShell>
      <TopBar back={false} />
      <main className="px-5 pb-28 pt-2 lg:px-8 lg:pb-16" data-testid="search-page">
        <h1 className="h-display text-4xl lg:text-5xl">{t("search_h1")}</h1>
        <p className="mt-2 text-sm text-rox-off/75" data-testid="pairs-count">
          {pairs === null
            ? t("analyzing")
            : pairs.length === 0
              ? t("none_compatible")
              : filtering
                ? t("filtered_count", visible.length, pairs.length)
                : t("search_sub", pairs.length)}
        </p>
        <NotificationsBanner />
        <RaceCountdown races={races} myRace={profile?.race} />
        {pairs?.length > 0 && <FiltersDrawer races={races.filter((r) => r.id !== "other")} cities={cities} filters={filters} onApply={setFilters} />}
        <div className="mt-5 grid grid-cols-1 gap-4 stagger lg:grid-cols-2 xl:grid-cols-3" key={JSON.stringify(filters)}>
          {visible.map((p) => <PairCard key={p.id} pair={p} />)}
        </div>
        {pairs?.length === 0 && (
          <div className="panel mt-6 p-6 text-sm text-rox-off/75">{t("widen_search")}</div>
        )}
        {pairs?.length > 0 && visible.length === 0 && (
          <div className="panel mt-6 flex items-center justify-between gap-4 p-5 text-sm text-rox-off/75" data-testid="filters-empty">
            {t("none_with_filters")}
            <button data-testid="filters-empty-reset" onClick={() => setFilters(DEFAULT_FILTERS)} className="shrink-0 font-display text-sm uppercase tracking-wider text-rox-orange">{t("reset")}</button>
          </div>
        )}
      </main>
      <AppFooter />
      <BottomNav />
    </AppShell>
  );
}
